var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ymap-marker',{attrs:{"coords":[_vm.latitude, _vm.longitude],"icon":_vm.icon,"marker-type":"placemark","marker-id":"plane","hint-content":"Самолётик"}})}
var staticRenderFns = []

export { render, staticRenderFns }